import React, { Component } from 'react'
import RequestTFACode from '../requestTFACode.js'

const dataProtectionButton = props => {
    const translation = JSON.parse(localStorage.translation)[localStorage.language]
    let {
        tfa_code,
        tfa_code_requested,
        tfaCodeRequestRequired,
        TFAcodeReceived,
        checkButtonClicked,
    } = props

    return (
        <div className="data-protection__buttons">
            {tfaCodeRequestRequired && !tfa_code_requested ? (
                <button
                    className="data-protection__buttons_getCode"
                    onClick={() =>
                        RequestTFACode({
                            success: TFAcodeReceived,
                        })
                    }
                >
                    {translation['Get code']}
                </button>
            ) : null}
            {(tfaCodeRequestRequired && tfa_code_requested) ||
            (!tfaCodeRequestRequired && !tfa_code_requested) ? (
                <button
                    className={
                        tfa_code.length === 6
                            ? 'data-protection__buttons_check __active'
                            : 'data-protection__buttons_check'
                    }
                    onClick={checkButtonClicked}
                >
                    {translation['Check']}
                </button>
            ) : null}
        </div>
    )
}

export default dataProtectionButton
